import styled from 'styled-components';

export const Container = styled.div`
	margin-bottom: 12px;
	margin-left: 1px;
`;
